/** Short time for message headers: "3:17 PM" today, "Oct 28, 3:17 PM" otherwise. Full value belongs in a title. */
export function formatShortTime(ts?: string) {
  if (!ts) return '';
  try {
    const d = new Date(ts);
    const time = d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    if (d.toDateString() === new Date().toDateString()) return time;
    return `${d.toLocaleDateString([], { month: 'short', day: 'numeric' })}, ${time}`;
  } catch { return ''; }
}
